import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {RockBottomGameAssets} from "./RockBottomGameAssets";
import {RockBottomSound} from "./sound/RockBottomSound";
import {RockBottomBackground} from "./view/RockBottomBackground";
import {RockBottomWinPresentation} from "./gameflow/RockBottomWinPresentation";
import {RockBottomNormalBetPresentation} from "./gameflow/RockBottomNormalBetPresentation";
import {RockBottomNormalResultPresentation} from "./gameflow/RockBottomNormalResultPresentation";
import {RockBottomNormalIdlePresentation} from "./gameflow/RockBottomNormalIdlePresentation";
import {RockBottomModel} from "./server/RockBottomModel";
import {RockBottomLayers} from "./view/RockBottomLayers";
import {RockBottomReelController} from "./reels/RockBottomReelController";
import {RockBottomGameConfig} from "./RockBottomGameConfig";
import {ReelStopPresentationManager} from "./reelstoppresentation/ReelStopPresentationManager";
import {ReelStopSoundController} from "./reelstoppresentation/presentations/ReelStopSoundController";
import {WinPresentationManager} from "./winpresentation/WinPresentationManager";
import {ScatterLandingController} from "./reelstoppresentation/presentations/ScatterLandingController";
import {XSplitLandingController} from "./reelstoppresentation/presentations/XSplitLandingController";
import {InitialWinCountUp} from "./winpresentation/presentations/initial/InitialWinCountUp";
import {BigWinCountUp} from "./winpresentation/presentations/bigwin/BigWinCountUp";
import {BigWinController} from "./winpresentation/presentations/bigwin/BigWinController";
import {InitialWinController} from "./winpresentation/presentations/initial/InitialWinController";
import {NoWinSymbolsController} from "./winpresentation/presentations/NoWinSymbolsController";
import {IndividualWinController} from "./winpresentation/individual/IndividualWinController";
import {FreespinIntro} from "./screen/FreespinIntro";
import {RockBottomFreespinIdlePresentation} from "./gameflow/RockBottomFreespinIdlePresentation";
import {FreespinWinController} from "./winpresentation/presentations/FreespinWinController";
import {FreespinOutro} from "./screen/FreespinOutro";
import {FreespinEndController} from "./winpresentation/presentations/FreespinEndController";
import {WinCapScreen} from "./screen/WinCapScreen";
import {BreakBankController} from "./winpresentation/presentations/BreakBankController";
import {BelowStakeWinRestriction} from "./server/BelowStakeWinRestriction";
import {RockBottomReelBackground} from "./view/RockBottomReelBackground";
import {RockBottomGameMode} from "./server/RockBottomGameMode";
import {RockBottomParsedGameData} from "./server/data/RockBottomParsedGameData";
import {RockBottomParsedInitData} from "./server/data/RockBottomParsedInitData";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {ISymbolValues} from "./server/data/IRockBottomData";
import {
    RockBottomReelStopPresentationController
} from "./reelstoppresentation/presentations/RockBottomReelStopPresentationController";
import {SpinePlayer} from "../core/utils/SpinePlayer";
import {ScatterNudgeController} from "./winpresentation/presentations/ScatterNudgeController";
import {RockBottomFreeSpinView} from "./view/RockBottomFreeSpinView";
import {MidSymLandingController} from "./reelstoppresentation/presentations/MidSymLandingController";
import {RockBottomMidSymExpandView} from "./view/RockBottomMidSymExpandView";
import {XSplitController} from "./winpresentation/presentations/XSplitController";
import {RockBottomXBetView} from "./view/RockBottomXBetView";
import {BonusFeatureData} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/BonusFeatures";
import {DrinkController} from "./winpresentation/presentations/DrinkController";
import {RockBottomCharacterIntro} from "./view/RockBottomCharacterIntro";
import {RBSoftWinCapPresentation} from "./gameflow/RBSoftWinCapPresentation";
import {RBSoftWinCapView} from "./view/RBSoftWinCapView";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {JurisdictionNames} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/GameClientConfiguration";
import {InitialWinMultView} from "./winpresentation/presentations/initial/InitialWinMultView";
import {RockBottomAnticipationView} from "./view/RockBottomAnticipationView";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {RockBottomXSplitView} from "./view/RockBottomXSplitView";
import {RockBottomForeground} from "./view/RockBottomForeground";
import {GameModelEvent} from "@nolimitcity/slot-game/bin/model/GameModel";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {NJReqWinView} from "./winpresentation/presentations/NJReqWinView";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";
import {rootCertificates} from "tls";


export class RockBottom extends SlotGame {
    public static isActionSpinsActive: boolean = false;
    public static model: RockBottomModel;
    public static gameFlowController: GameFlowController;
    public static assetLoader: AssetLoader;
    public static reels: RockBottomReelController[];
    public static reelStopPresentations: ReelStopPresentationManager;
    public static winPresentations: WinPresentationManager;
    public static njReqWinView: NJReqWinView;
    public static initialCountUp: InitialWinCountUp;
    public static initialWinMult: InitialWinMultView;
    public static anticipationView: RockBottomAnticipationView;
    public static bigWinCountUp: BigWinCountUp;
    public static individualWin: IndividualWinController;
    public static freespinIntro: FreespinIntro;
    public static freespinOutro: FreespinOutro;
    public static freeSpinView: RockBottomFreeSpinView;
    public static winCapScreen: WinCapScreen;
    public static reelBg: RockBottomReelBackground;
    public static background: RockBottomBackground;
    public static foreground: RockBottomForeground;
    public static midSymExpand: RockBottomMidSymExpandView;
    public static pickAndClickView: RBSoftWinCapView;
    public static xBetView: RockBottomXBetView;
    public static xSplitView: RockBottomXSplitView;
    public static characterIntro: RockBottomCharacterIntro;

    private static isInBonusGame: boolean = false;
    private skinner: Skinner;

    constructor() {
        super();
        const validSkins: string[] = [
            "sweep"
        ]
        this.skinner = new Skinner(validSkins);
    }

    private handleSweepInit() {
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                this.skinner.skinId = "sweep";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    this.skinner.skinId = "sweep";
                }
            })
        }
    }

    private handleSweepGetReady(): Promise<any> {
        if (this.skinner.skinId != undefined) {
            const replaceMap: Map<string, string> = new Map();

            replaceMap.set("BOOSTED_BET", "BOOSTED_BET.png");
            replaceMap.set("pageImage_5", "pageImage_5.png");
            replaceMap.set("betBoost", "intro_feature4.png");

            replaceMap.set("xBet/xBet", "xplay.png");
            replaceMap.set("xBet/xBetFlush", "xplayFlush.png");
            replaceMap.set("X_bet_Glow", "X_bet_Glow.jpg");
            return this.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }

    public static get inBonusGame(): boolean {
        return this.isInBonusGame;
    }

    public static get isIpad(): boolean {
        const resizeData: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            return (resizeData.width >= 955 && resizeData.width <= 965);
        } else {
            return (resizeData.height >= 955 && resizeData.height <= 965);
        }
    }

    private static getSymbolString(key: string, data: { [numSymbols: number]: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.jpg">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    private static createViewsAndComponents() {
        //Non views
        const sound: RockBottomSound = new RockBottomSound(),
            layers: RockBottomLayers = new RockBottomLayers();

        //Views
        SpinePlayer.setSpineLoader(RockBottom.assetLoader);
        RockBottom.background = new RockBottomBackground();
        RockBottom.foreground = new RockBottomForeground();
        RockBottom.midSymExpand = new RockBottomMidSymExpandView();
        RockBottom.initialCountUp = new InitialWinCountUp();
        RockBottom.initialWinMult = new InitialWinMultView();
        RockBottom.anticipationView = new RockBottomAnticipationView();
        RockBottom.bigWinCountUp = new BigWinCountUp();
        RockBottom.njReqWinView = new NJReqWinView();
        RockBottom.freespinIntro = new FreespinIntro();
        RockBottom.freespinOutro = new FreespinOutro();
        RockBottom.freeSpinView = new RockBottomFreeSpinView();
        RockBottom.pickAndClickView = new RBSoftWinCapView();
        RockBottom.winCapScreen = new WinCapScreen();
        RockBottom.characterIntro = new RockBottomCharacterIntro();

        RockBottom.reels = [];
        for (let i: number = 0; i < RockBottomGameConfig.REELS_NUM; i++) {
            const reel = new RockBottomReelController(i);
            RockBottom.reels.push(reel);
        }
        RockBottom.reelStopPresentations = new ReelStopPresentationManager([
            new RockBottomReelStopPresentationController(),
            new ReelStopSoundController(),
            new MidSymLandingController(),
            new ScatterLandingController(),
            new XSplitLandingController()
        ]);
        RockBottom.winPresentations = new WinPresentationManager([
            new XSplitController(),
            new NoWinSymbolsController(),
            new InitialWinController(),
            new BigWinController(),
            new ScatterNudgeController(),
            new DrinkController(),
            new FreespinWinController(),
            new FreespinEndController(),
            new BreakBankController()
        ]);
        RockBottom.individualWin = new IndividualWinController();
        RockBottom.reelBg = new RockBottomReelBackground();
        RockBottom.xBetView = new RockBottomXBetView();
        RockBottom.xSplitView = new RockBottomXSplitView();

        if (RockBottom.model.isRestore) {
            const parsedData: RockBottomParsedInitData = RockBottom.model.parsedInitData,
                currMode: RockBottomGameMode = parsedData.mode,
                showTotalWin: boolean = (currMode === RockBottomGameMode.FREESPIN || currMode === RockBottomGameMode.SUPER_FREESPIN);

            SlotGame.keypadPlugin.setWin(parsedData.totalWin, showTotalWin, BelowStakeWinRestriction.isWinBelowStake());
        }

        RockBottom.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any) => {
            if (data === true) {
                RockBottom.isActionSpinsActive = true;
                RockBottom.individualWin.stop();
            } else {
                RockBottom.isActionSpinsActive = false;
            }
        });
        // If restore, can be handled in these constructors directly.
    }

    public static setBonusMode(value: boolean): void {
        this.isInBonusGame = value;
    }

    public static getParsedData(): RockBottomParsedGameData | RockBottomParsedInitData {
        return RockBottom.model.parsedGameData ? RockBottom.model.parsedGameData : RockBottom.model.parsedInitData;
    }

    public static isBoostedBetAllowed(): boolean {
        return RockBottom.apiPlugin.gameClientConfiguration.boostedBetAllowed;
    }

    // this is required to compare "singleWin" only.
    public static getBetPriceForSingleWin(): number {
        const featureData: BonusFeatureData | undefined = RockBottom.apiPlugin.bonusFeatures.getFeatureDataByName("BOOSTED_BET"),
            betLevel: string = RockBottom.apiPlugin.freeBets.hasFreeBets() ? RockBottom.apiPlugin.freeBets.getBet() : RockBottom.apiPlugin.betLevel.getLevel();
        let price: number = RockBottom.model.parsedGameData.playedBetValue || parseFloat(betLevel);

        if (featureData && RockBottomGameConfig.IS_BOOSTED_BET) {
            price *= featureData.price;
        }
        return price;
    }

    public static isPortugal(): boolean {
        return RockBottom.apiPlugin.gameClientConfiguration.jurisdictionName === JurisdictionNames.PORTUGAL;
    }

    public static isRestoredOnPick(): boolean {
        const parsedGameData: RockBottomParsedGameData = RockBottom.model.parsedGameData,
            parsedInitData: RockBottomParsedInitData = RockBottom.model.parsedInitData;

        return (parsedGameData.mode === RockBottomGameMode.WINCAP_PICK && parsedInitData.nextMode === RockBottomGameMode.WINCAP_PICK);
    }

    public async init(): Promise<NolimitPlugin> {
        const value = await super.init();

        RockBottomGameConfig.updateReelSets();
        RockBottom.model = new RockBottomModel(SlotGame.apiPlugin, true);
        RockBottom.gameFlowController = new GameFlowController(SlotGame.apiPlugin, RockBottom.model);
        RockBottom.gameFlowController.flowStateLogger.level = LogLevel.DEV;

        RockBottom.model.events?.on(GameModelEvent.GAME, (data: any) => {
            console.log("RockBottom class GameModelEvent.GAME", data);
        });

        const idleNormal = new RockBottomNormalIdlePresentation(),
            reelStart = new RockBottomNormalBetPresentation(),
            normalResult = new RockBottomNormalResultPresentation(),
            freespinIdle = new RockBottomFreespinIdlePresentation(),
            winPres = new RockBottomWinPresentation(),
            softWinCapPick = new RBSoftWinCapPresentation();

        RockBottom.gameFlowController.addGameModeFlowStatePresentationMap(RockBottomGameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, idleNormal],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));

        RockBottom.gameFlowController.addGameModeFlowStatePresentationMap(RockBottomGameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));

        RockBottom.gameFlowController.addGameModeFlowStatePresentationMap(RockBottomGameMode.SUPER_FREESPIN, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, freespinIdle],
            [FlowState.BET, reelStart],
            [FlowState.RESULT, normalResult],
            [FlowState.WIN, winPres]
        ]));

        RockBottom.gameFlowController.addGameModeFlowStatePresentationMap(RockBottomGameMode.WINCAP_PICK, new Map<FlowState, FlowStatePresentation>([
            [FlowState.IDLE, softWinCapPick],
            [FlowState.RESULT, softWinCapPick],
            [FlowState.WIN, winPres]
        ]));
        this.handleSweepInit();
        return value;
    }

    public async getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        const value = await super.getReady(),
            fontLoader = new FontLoader(NolimitApplication.resourcePath);

        fontLoader.add(OpenSans.ITALIC_600);
        fontLoader.add(OpenSans.NORMAL_300);
        fontLoader.add(OpenSans.NORMAL_400);
        fontLoader.add(OpenSans.NORMAL_700);
        fontLoader.add({
            family: "BadaBoom",
            weight: FontWeight.NORMAL,
            style: FontStyle.NORMAL,
            url: "/resources/fonts/BADABB__.TTF"
        });

        AssetsConfig.addToAssetsConfig(RockBottomGameAssets.RESOURCES_GROUPS);
        RockBottom.assetLoader = new AssetLoader(RockBottom.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        await Promise.all([fontLoader.load(), RockBottom.assetLoader.load(ResourcesGroupName.MAIN)]);
        await this.handleSweepGetReady();
        RockBottom.createViewsAndComponents();

        if (RockBottom.apiPlugin.freeBets.hasFreeBets()) {
            RockBottom.xBetView.turnOffXBet(true);

            RockBottom.apiPlugin.freeBets.events.once(SlotGame.apiPlugin.freeBets.FREE_BETS_END, () => {
                RockBottom.xBetView.turnOffXBet(false);
            });
        } else if (RockBottom.model.isRestore && RockBottom.model.initData.enhancedBetPlayed) {
            RockBottom.xBetView.turnOnXBet(false);
        }

        RockBottom.apiPlugin.freeBets.events.on(SlotGame.apiPlugin.freeBets.FREE_BETS_START, () => {
            RockBottom.xBetView.turnOffXBet(true);
        });
        RockBottom.apiPlugin.freeBets.events.on(SlotGame.apiPlugin.freeBets.FREE_BETS_END, () => {
            RockBottom.xBetView.turnOffXBet(false);
            RockBottom.xBetView.enableXBetBtn(true,0);
        });

        return value;
    }

    public async getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, showing intro, waiting for user to start game.
        RockBottomSound.switchMusic(
            {name: RockBottomSound.MAIN_GAME_MUSIC, volume: 0},
            {name: RockBottomSound.MAIN_GAME_MUSIC, from: 0, to: 1, duration: 1000}
        );

        return await super.getReadyToStart();
    }

    public async start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        const value = await super.start(),
            parsedGameData: RockBottomParsedGameData | RockBottomParsedInitData = RockBottom.getParsedData();

        RockBottom.background.updateBackGround(parsedGameData.mode);
        RockBottom.gameFlowController.start();
        RockBottomSound.switchMusic({name: RockBottomSound.getMusicNameByMode(RockBottom.model.data.mode)});

        if (!RockBottom.apiPlugin.isReplay && !RockBottom.model.isRestore && RockBottom.model.parsedInitData.mode === RockBottomGameMode.NORMAL) {
            RockBottom.characterIntro.playCharacterIntro();
        }

        return value;
    }


    private paytable:string = require("../../nolimit/screens/paytable.mustache");
    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            const data = {
                skinPath: "screens/images/"
            };
            if (this.skinner.skinId != undefined) {
                data.skinPath = `../resources/images/${this.skinner.skinId}/`;
            }
            let symbolDataValueData: ISymbolValues = {
                "L1": {3: 5, 4: 10, 5: 20},
                "L2": {3: 5, 4: 10, 5: 20},
                "L3": {3: 4, 4: 8, 5: 15},
                "L4": {3: 3, 4: 6, 5: 15},
                "L5": {3: 3, 4: 6, 5: 15},
                "M1": {3: 15, 4: 30, 5: 80},
                "M2": {3: 10, 4: 20, 5: 60},
                "M3": {3: 9, 4: 18, 5: 40},
                "M4": {3: 8, 4: 16, 5: 25},
                "M5": {3: 7, 4: 14, 5: 25}
            };
            if (RockBottom.model.parsedInitData.symbolValues) {
                symbolDataValueData = RockBottom.model.parsedInitData.symbolValues;
                Logger.logDev("Using symbolValues from INIT data");
            } else {
                Logger.logDev("Using default symbolValues");
            }
            let paytableString: string = (<any>this.paytable).text;
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);
            for (let key in symbolDataValueData) {
                paytableString = paytableString.replace(`{{${key}}}`, RockBottom.getSymbolString(key, symbolDataValueData[key]));
            }
            resolve(paytableString);
        });
    }
    //below code needed for fixing #186
    getNoWinGameData(): any {
        return {
            "reels": [
                ["L3", "L4", "L4", "L4", "L3"],
                ["L1", "L1", "M3", "M3", "M4", "M3"],
                ["M3", "M1", "L4", "L3", "L3", "L4"],
                ["L5", "M1", "M2", "L5", "L4", "L1"],
                ["M5", "L2", "L2", "L5", "L1"]
            ],
            "evaluatedArea": [
                ["L4", "L4", "L4"],
                ["L1", "M3", "M3", "M4"],
                ["M1", "L4", "L3", "L3"],
                ["M1", "M2", "L5", "L4"],
                ["L2", "L2", "L5"]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "freespinTriggeredThisSpin": false,
            "symbolSizes": [
                [1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1, 1],
                [1, 1, 1]
            ],
            "wasFeatureBuy": false,
            "brokeTheBank": false,
            "enhancedBet": false,
            "scatterReels": [false, false, false, false, false],
            "capWinMultiplier": 1,
            "softWinCapTriggered": false,
            "fsSymbolMultiplier": [1, 1, 1, 1, 1],
            "playerInteraction": {},
            "fsLevel": 0,
            "collectedScatters": 0,
            "fsLevelNextSpin": 0
        }
    }
}